import { z } from 'zod';
import { PostReportMode } from '@anytag/shared-types';
import { SearchSchema } from '@anytag/shared-validations';
import { TikTokSpecialReportOrderField } from '@anytag/graphql';
import { PostReportFilterSchema } from '@anytag/shared-organisms';

export const TikTokPostReportSearchSchema = SearchSchema.create({
  sort: { field: TikTokSpecialReportOrderField },
  filter: {
    schema: PostReportFilterSchema,
    defaultValues: {
      endDate: undefined, // NOTE: undefined is needed to set the default period if the filter is not set
      startDate: undefined,
      mode: PostReportMode.GRID
    }
  }
});

export type TikTokPostReportSearchSchemaType = z.infer<typeof TikTokPostReportSearchSchema>;
